import { render, staticRenderFns } from "./adviser.vue?vue&type=template&id=37f1e481&scoped=true&"
import script from "./adviser.vue?vue&type=script&lang=js&"
export * from "./adviser.vue?vue&type=script&lang=js&"
import style0 from "./adviser.vue?vue&type=style&index=0&id=37f1e481&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f1e481",
  null
  
)

export default component.exports